import React from 'react';
import { useTenant } from '@/contexts/TenantContext';
import { useLanguage } from '@/contexts/LanguageContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { Building2, Loader2, ArrowLeftRight } from 'lucide-react';

export default function TenantSelector() {
  const { effectiveTenantId, tenants, loading, selectTenant, isPlatformAdmin, selectedTenant } = useTenant();
  const { language } = useLanguage();
  const fr = language === 'fr';

  if (!isPlatformAdmin) return null;

  if (loading) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-purple-50 rounded-lg border border-purple-200">
        <Loader2 size={16} className="animate-spin text-purple-600" />
        <span className="text-sm text-purple-600">{fr ? 'Chargement...' : 'Loading...'}</span>
      </div>
    );
  }

  if (tenants.length === 0) {
    return (
      <div className="px-3 py-2 bg-amber-50 rounded-lg border border-amber-200">
        <span className="text-sm text-amber-700">{fr ? 'Aucun tenant' : 'No tenants'}</span>
      </div>
    );
  }

  return (
    <div className="space-y-2" data-testid="tenant-selector">
      <div className="flex items-center gap-2">
        <ArrowLeftRight size={14} className="text-purple-600" />
        <span className="text-xs font-semibold text-purple-700 uppercase tracking-wide">
          {fr ? 'Vue Tenant' : 'Tenant View'}
        </span>
      </div>
      <Select value={effectiveTenantId || ''} onValueChange={selectTenant}>
        <SelectTrigger className="w-full bg-white border-purple-200 focus:ring-purple-500 text-sm" data-testid="tenant-select-trigger">
          <SelectValue placeholder={fr ? 'Choisir un tenant' : 'Select tenant'} />
        </SelectTrigger>
        <SelectContent>
          {tenants.map((tenant) => (
            <SelectItem key={tenant.id} value={tenant.id} data-testid={`tenant-option-${tenant.code || tenant.id.slice(0,6)}`}>
              <div className="flex items-center gap-2">
                <Building2 size={14} className="text-slate-400" />
                <span className="font-medium">{tenant.name}</span>
                {tenant.code && (
                  <span className="text-xs text-slate-400">{tenant.code}</span>
                )}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {selectedTenant && (
        <p className="text-xs text-purple-600 truncate">
          {selectedTenant.name}
        </p>
      )}
    </div>
  );
}
